module.exports = __webpack_public_path__ + "img/960.47d13914.svg";